"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-await-in-loop */
const legacyForEachBuilder = () => async ({ functionId, callbacks, executeProcesses, entryVars: { collection, }, }) => {
    const indexes = [];
    if (Array.isArray(collection)) {
        for (let i = 0; i < collection.length; i += 1) {
            indexes.push(i);
            await executeProcesses(functionId, callbacks.onIteration, {
                key: i,
                item: collection[i],
                index: i,
            });
        }
    }
    else if (typeof collection === 'object') {
        const entries = Object.entries(collection || {});
        for (let i = 0; i < entries.length; i += 1) {
            indexes.push(i);
            const [key, item] = entries[i];
            await executeProcesses(functionId, callbacks.onIteration, {
                key,
                item,
                index: i,
            });
        }
    }
    else {
        await executeProcesses(functionId, callbacks.onNonIterableCollection, {
            key: 0,
            item: collection,
        });
    }
};
exports.default = legacyForEachBuilder;
